import { render, staticRenderFns } from "./JournalProcess.vue?vue&type=template&id=44cff724"
import script from "./JournalProcess.vue?vue&type=script&lang=js"
export * from "./JournalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports